import { ForceUseExternalPod, IsDSM, IsImpersonationMode, IsProduction, PODUrl } from 'config/config';
import { DealerPortalSectionEnumValue, getDealerPortalSectionValue } from 'enums/DealerPortalSectionEnum';

export const shouldUseLegacyPodUrl = () => ForceUseExternalPod || (IsProduction && (!IsImpersonationMode || IsDSM));

export const isPrintOnDemandSection = sectionNameOrValue =>
  getDealerPortalSectionValue(sectionNameOrValue) === DealerPortalSectionEnumValue.PrintOnDemand;

export const getPodLinkBehavior = internalUrl => {
  if (shouldUseLegacyPodUrl()) {
    return {
      url: PODUrl,
      isExternalRoute: true,
      openInNewTab: true,
    };
  }

  return {
    url: internalUrl,
    isExternalRoute: false,
    openInNewTab: false,
  };
};
